import { UI } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

export interface InputEditIconProps {
  onPress: () => void;
  disabled?: boolean;
}

export const InputEditIcon: React.FC<InputEditIconProps> = ({ onPress, disabled }) => {
  return (
    <Pressable onPress={onPress} pr={2} isDisabled={disabled}>
      <UI.Icon
        testID="input-edit-icon"
        name="EditPen"
        size="xxxs"
        color={Color['brand.tertiary.principal']}
      />
    </Pressable>
  );
};
